import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c0a45bce"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "head-logo"
};
const _hoisted_3 = {
  href: "/index.html"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "nav-btn-list"
};
const _hoisted_6 = ["href", "target"];
const _hoisted_7 = {
  class: "head-infor"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = {
  key: 0,
  class: "head-login"
};
const _hoisted_10 = {
  key: 1,
  class: "head-user"
};
const _hoisted_11 = {
  class: "avatar-box"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "user-name"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("申请审核");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("账号设置");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("管理后台");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("退出");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_ApplyTeachingRoomDialog = _resolveComponent("ApplyTeachingRoomDialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", _hoisted_3, [_createElementVNode("img", {
    src: $data.logoUrl,
    alt: ""
  }, null, 8, _hoisted_4)])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navList.slice(0, 10), ({
    nav_name,
    target_url,
    target_type
  }, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["nav-btn", $data.currentPage === nav_name ? 'nav-active' : '']),
      key: index
    }, [_createElementVNode("a", {
      href: target_url,
      class: "noticenav",
      target: target_type ? '_blank' : '_self'
    }, _toDisplayString(nav_name), 9, _hoisted_6)], 2);
  }), 128))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
    class: "join-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleApply && $options.handleApply(...args))
  }, "加入教研室"), _createElementVNode("a", {
    class: "online",
    href: $data.userInfo ? '/teachingCenter.html' : '/login.html?service=/teachingCenter.html',
    target: "_blank"
  }, " 我的教研室 ", 8, _hoisted_8), $data.showLogin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
    class: "login-btn",
    onClick: _cache[1] || (_cache[1] = $event => $options.handleLogin())
  }, "登录")])) : _createCommentVNode("", true), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    class: "avatar",
    src: $data.userInfo.avatar ? $data.userInfo.avatar : require('@/assets/images/common/teacher_icon.png')
  }, null, 8, _hoisted_12)]), _createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [$data.isCheck ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
        key: 0,
        onClick: $options.handleCheck
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          icon: "申请审核",
          "class-name": "dropdown-icon"
        }), _hoisted_14]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, {
        onClick: $options.goAccountSet
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          icon: "账号设置",
          "class-name": "dropdown-icon"
        }), _hoisted_15]),
        _: 1
      }, 8, ["onClick"]), $data.userInfo && $data.userInfo.roleId ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
        key: 1,
        onClick: $options.handleAdmin
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          icon: "管理后台",
          "class-name": "dropdown-icon"
        }), _hoisted_16]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, {
        onClick: $options.handleLogout
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          icon: "退出",
          "class-name": "dropdown-icon"
        }), _hoisted_17]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString($data.userInfo.realname), 1)]),
    _: 1
  })])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])]), $data.showApplyDialog ? (_openBlock(), _createBlock(_component_ApplyTeachingRoomDialog, {
    key: 0,
    show: $data.showApplyDialog,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.showApplyDialog = $event)
  }, null, 8, ["show"])) : _createCommentVNode("", true)], 64);
}